<script setup>
import { onMounted, onUnmounted } from 'vue';
import { запрос, ответить } from '../composables/useConfirm.js';
import { useOffice } from '../i18n/office.js';

const { to } = useOffice();

/* Один диалог подтверждения на всё приложение. Монтируется в App.vue,
   вызывается из любого места через подтвердить().

   Клавиши обязательны: у мастера и планировщика клавиатура есть, и Escape
   с Enter здесь ожидаются. У оператора клавиатуры нет — ему остаются
   кнопки, и они крупные. */

function поКлавише(e) {
  if (!запрос.value.open) return;
  if (e.key === 'Escape') { e.preventDefault(); ответить(false); }
  if (e.key === 'Enter') { e.preventDefault(); ответить(true); }
}

onMounted(() => window.addEventListener('keydown', поКлавише));
onUnmounted(() => window.removeEventListener('keydown', поКлавише));
</script>

<template>
  <div v-if="запрос.open" class="backdrop" @click.self="ответить(false)">
    <div class="card sheet" role="alertdialog" aria-modal="true">
      <div class="card-head">
        <strong>{{ запрос.title || to('Подтвердите действие') }}</strong>
        <button type="button" class="btn btn-ghost x" @click="ответить(false)">✕</button>
      </div>
      <div class="body">
        <p class="text">{{ запрос.text }}</p>
        <!-- Подробность отдельной строкой и тусклее: главный вопрос должен
             читаться первым, а последствие — вторым, а не наоборот. -->
        <p v-if="запрос.detail" class="dim small nomg">{{ запрос.detail }}</p>

        <div class="acts-end">
          <button type="button" class="btn" @click="ответить(false)">{{ запрос.cancelLabel }}</button>
          <button type="button" class="btn" :class="запрос.danger ? 'btn-danger' : 'btn-primary'"
                  @click="ответить(true)">{{ запрос.confirmLabel }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.backdrop { position: fixed; inset: 0; z-index: 90; display: grid; place-items: start center;
  padding: 24px 20px; overflow: auto; background: rgba(0,0,0,.5); backdrop-filter: blur(2px); }
.sheet { width: 100%; max-width: 460px; background: var(--bg-2); }
.x { min-height: 32px; padding: 0 10px; }
.body { padding: var(--gap); display: flex; flex-direction: column; gap: 12px; }
.text { margin: 0; }
.nomg { margin: 0; }
.acts-end { display: flex; justify-content: flex-end; gap: 10px; padding-top: 4px; }
/* На планшете кнопки крупные: подтверждают в перчатках. */
.acts-end .btn { min-height: 44px; padding: 0 20px; }
</style>
